import type { Tenant } from "../Tenant.js";
import { getCareerPath } from "./getCareerPath.js";

export interface CareerPositionPathInput {
	slug: string;
}

export const getCareerPositionDetailPath = (tenant: Tenant, position: CareerPositionPathInput): string => {
	const careerPath = getCareerPath(tenant);
	return `${careerPath}/${position.slug}`;
};
